module.exports = ".button {\n    cursor: pointer;\n}\n\n.fill {\n    fill:#BABAAB;\n    stroke-width:1;\n}\n\n.file_input {\n    display:none;\n}\n\n.text {\n    letter-spacing: 2px;\n    font-weight: 400;\n}\n\n.loading {\n  fill:#BABAAB;\n  display:none;\n}\n\n.slider-text {\n    display: block;\n    text-align: center;\n    font-family: 'Arial';\n    font-size: 0.7rem;\n    font-weight: 400;\n    letter-spacing: 2px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/motorbutton/motorbutton.component.css
// module id = ./src/app/motorbutton/motorbutton.component.css
// module chunks = main